<template>
  <base-modal
    class="modal search-panel"
    :modal-id="modalId"
    :hide-footer="true"
    :hide-header="true"
  >
    <template v-slot:header>
      <div
        class="d-flex"
        style="
          justify-content: space-between;
          align-items: baseline;
          width: 100vw;
        "
      >
        <div class="back-arrow" @click.prevent="closeModal()">
          <img
            src="/images/svg/global/left_arrow.svg"
            class="img-fluid"
            alt=""
          />
        </div>
        <div class="mobile-search"><search-bar /></div>
      </div>
    </template>
    <template v-slot:modal-body>
      <BrandsList
        v-if="
          !domainBasedBrand &&
          getSearchTerm &&
          getSearchTerm.length > 0 &&
          getFilteredBrands.length > 0
        "
      ></BrandsList>
      <div v-else class="responsive-filter-sec">
        <div class="recent-search">
          <!-- <h5 class="title">{{ _T('Recent search') }}</h5>
          <ul>
            <li>
              <img src="/images/svg/global/clock.svg" />
              <h6>{{ _T('Ayam Bakar Haji Tohir') }}</h6>
            </li>
          </ul> -->
        </div>
        <!-- <h5 class="title">{{ _T('Filter') }}</h5>
        <div class="filter-part">
          <h6 class="type-title">{{ _T('order type') }}</h6>
          <ul class="order-type">
            <li class="active">{{ _T('Delivery') }}</li>
          </ul>
        </div>
        <div class="filter-part select-filter">
          <h6 class="type-title">{{ _T('food type') }}</h6>
          <div class="select-type">
            <select>
              <option value="1">{{ _T('All cousine') }}</option>
            </select>
          </div>
        </div> -->
      </div>
      <!-- <a
        v-if="!domainBasedBrand && getSearchTerm.length > 0"
        id="link_change"
        href="#"
        class="apply-btn btn btn-solid"
        >{{ _T('apply') }}</a
      > -->
    </template>
  </base-modal>
</template>

<script>
import BaseModal from '@/components/Modals/BaseModal'
import SearchBar from '@/components/Blocks/SearchBar'
import BrandsList from '@/components/Blocks/BrandsList'
import { mapGetters } from 'vuex'
export default {
  name: 'MobileSearchModal',
  data: () => {
    return {
      modalId: 'open-search',
    }
  },
  components: {
    BaseModal,
    SearchBar,
    BrandsList,
  },
  computed: {
    ...mapGetters([
      '_T',
      'domainBasedBrand',
      'getSearchTerm',
      'getFilteredBrands',
    ]),
  },
  methods: {
    closeModal() {
      this.$store.commit('SET_SEARCH_TERM', '')
      this.$bvModal.hide(this.modalId)
    },
  },
}
</script>

<style lang="scss">
.body-rtl {
  .responsive-filter-sec {
    .filter-part {
      .select-type {
        select {
          background: url(/images/global/down.svg) no-repeat 4%;
        }
      }
      .order-type {
        li {
          + li {
            margin-left: unset;
            margin-right: 10px;
          }
        }
      }
      .type-title {
        text-align: right;
      }
    }
    .recent-search {
      li {
        h6 {
          margin-left: unset;
          margin-right: 5px;
        }
      }
    }
  }
}
#open-search {
  .modal-diaglog,
  .modal-md,
  .modal-dialog-centered {
    height: auto !important;
    margin: 0 !important;
  }
  .mobile-search {
    width: 100% !important;
    ::placeholder {
      font-size: $px14;
      line-height: $px17;
      color: $font-color;
      font-weight: normal;
    }
    form {
      display: flex;
      align-items: center;
      .form-group {
        width: 88%;
        margin-left: auto;
        position: relative;
        margin-bottom: 0;
        input {
          border-radius: 0;
          width: 100%;
          border: $px1 solid $dark-border;
        }
        .location-arrow {
          left: $px15;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          line-height: 1;
        }
      }
    }
  }
  .responsive-filter-sec {
    .recent-search {
      margin-bottom: $px30;
      li {
        display: flex;
        align-items: center;
        h6 {
          font-weight: 600;
          font-size: $px14;
          line-height: $px17;
          letter-spacing: 0.005em;
          color: $brown-color;
          margin-left: $px5;
          margin-bottom: 0;
        }
        + li {
          margin-top: $px16;
        }
      }
    }
    .title {
      text-transform: uppercase;
      color: $font-color;
      letter-spacing: 0.02em;
      font-weight: 600;
      line-height: $px19;
      margin-bottom: $px18;
    }

    .filter-part {
      margin-bottom: 24px;
      .type-title {
        font-weight: 500;
        line-height: 19px;
        letter-spacing: 0.02em;
        color: $font-color;
        text-transform: capitalize;
      }
      .order-type {
        display: flex;
        li {
          width: $px105;
          height: $px68;
          border-radius: $px4;
          border: $px1 solid $dark-border;
          font-style: normal;
          font-weight: 600;
          font-size: $px14;
          line-height: $px17;
          letter-spacing: 0.02em;
          color: $font-color;
          text-transform: capitalize;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          + li {
            margin-left: $px10;
          }
          &.active {
            background-color: $color-primary;
            color: $white;
          }
        }
      }
      .select-type {
        select {
          width: 100%;
          background-color: $white;
          height: $px40;
          border: $px1 solid $dark-border;
          background: url(/images/global/down.svg) no-repeat 96%;
          border-radius: $px4;
          padding: $px10 $px15;
          font-weight: normal;
          font-size: $px14;
          line-height: $px19;
          letter-spacing: 0.02em;
          color: $font-color;
          text-transform: capitalize;
          position: relative;
          -webkit-appearance: none;
          &:focus {
            outline: none;
          }
        }
      }
    }
  }
  .apply-btn {
    position: relative;
    text-transform: capitalize;
    padding-bottom: $px9;
    float: right;
    margin-top: $px30;
  }
  #open-search___BV_modal_header_ {
    min-height: 5rem;
  }
  #open-search___BV_modal_body_ {
    overflow: scroll;
  }
  #open-search___BV_modal_content_ {
    border: unset !important;
    border-radius: 0 !important;
    height: auto !important;
  }
}
</style>
